import { render, staticRenderFns } from "./Resetpswd.vue?vue&type=template&id=07f994ad&scoped=true&"
import script from "./Resetpswd.vue?vue&type=script&lang=js&"
export * from "./Resetpswd.vue?vue&type=script&lang=js&"
import style0 from "./Resetpswd.vue?vue&type=style&index=0&id=07f994ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f994ad",
  null
  
)

export default component.exports